module.exports = __webpack_public_path__ + "img/1518300922.dd0ee630.jpg";